import { render, staticRenderFns } from "./ProductList4.vue?vue&type=template&id=0aae9a8a&scoped=true&"
import script from "./ProductList4.vue?vue&type=script&lang=js&"
export * from "./ProductList4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aae9a8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oh/Projects/php_was2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aae9a8a')) {
      api.createRecord('0aae9a8a', component.options)
    } else {
      api.reload('0aae9a8a', component.options)
    }
    module.hot.accept("./ProductList4.vue?vue&type=template&id=0aae9a8a&scoped=true&", function () {
      api.rerender('0aae9a8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Content/components/ProductList4.vue"
export default component.exports